import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/data.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { RouteHistoryService } from 'src/app/shared/services/router-history.service';
import { GenericAhaGoldPromptComponent } from '../../generic/generic-aha-gold-prompt/generic-aha-gold-prompt.component';

@Component({
  selector: 'app-detail-aha-gold-dialog',
  templateUrl: './detail-aha-gold-dialog.component.html',
  styleUrls: ['./detail-aha-gold-dialog.component.scss'],
})
export class DetailAhaGoldDialogComponent implements OnInit, OnDestroy {
  constructor(
    private routeHistoryService: RouteHistoryService,
    private dialogService: DialogService,
    private navService: NavigationLibraryService,
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data.redirectFrom === 'player') {
      this.dataService.disablePlayerListener = true;
    }
    this.navService.focusContainer('actions', true, 0, true);
  }

  ngOnDestroy(): void {
    if (this.dataService.disablePlayerListener) {
      this.dataService.disablePlayerListener = false;
    }
  }

  cancelAction() {
    if (this.data.shouldGoBack) {
      this.dialogService.close();
      this.routeHistoryService.goBack();
      return;
    }
    /*  if (this.data.redirectFrom === PlayerContainerType.EPISODES) {
      this.routeHistoryService.goBack();
    } */
    this.dialogService.close();
  }

  learnHowAction() {
    this.data.action = 'go_back';
    this.dialogService.close();
    this.dialogService.openDialog(GenericAhaGoldPromptComponent, {
      data: this.data,
    });
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }

  disabled(event: Event) {
    event.stopPropagation();
  }
}
